import {
    ShieldCheck,
    Map,
    Mouse,
    HeartHandshake,
} from "lucide-react";
interface EngagementProps {
    parent?: string;
}
const MissionSection: React.FC<EngagementProps> = ({ parent }) => {
    const commitments = [
        {
            icon: <ShieldCheck size={32} className="flex-shrink-0 mt-[6px] text-background_sd" />,
            title: "Votre voyage, notre priorité",
            description: "À votre écoute à chaque instant de votre voyage, nous restons disponibles 24h/24 et 7j/7.",
        },
        {
            icon: <Map size={32} className="flex-shrink-0 mt-[6px] text-background_sd" />,
            title: "Expériences Sur-Mesure",
            description: "Voyagez autrement avec des itinéraires uniques, créés par nous, selon votre style d’aventure.",
        },
        {
            icon: <HeartHandshake size={32} className="flex-shrink-0 mt-[6px] text-background_sd" />,
            title: "L'aventure en Confiance",
            description: "Roulez en toute sérénité : aucun frais caché, véhicules fiables et parfaitement entretenus.",
        },
        {
            icon: <Mouse size={32} className="flex-shrink-0 mt-[6px] text-background_sd" />,
            title: "Réservation Simplifiée",
            description: "Réservez en quelques clics avec notre système intuitif. Options flexibles, 100 % plaisir.",
        },
    ];

    return (
        <section className="w-full bg-background pt-24" >
            <div className="flex items-center justify-center w-[100vw] bg-contact_bis">

                <div className="w-full text-center flex flex-col items-center justify-center relative py-8 sm:py-16 px-4 sm:px-12 semi:px-16">
                    <div className="w-full h-full bg-black/10 absolute top-0 left-0 rounded-xl"></div>

                    <h3 className="pl-2 pb-8 sm:mb-8 font-bold text-background_sd text-5xl">Notre mission</h3>

                    <p className="pl-2 text-gray-100 max-w-[100%] sm:max-w-[65%] semi:max-w-[40%] text-pretty mb-6 sm:mb-10 text-xl">
                        « Vous offrir bien plus qu’une simple location : une aventure pensée pour vous, authentique, libre et inoubliable. »
                    </p>
                    <p className="signature text-center text-background_sd dark:text-[#17252A] text-4xl">Florine & David</p>

                </div>
            </div>
        </section>
    );
};

export default MissionSection;